import favrhoodLogo from '../../Assets/Projects/favrhood_logo1.png';

import ethAppImage from '../../Assets/EthiApp.png';
import mathBuddyImage from '../../Assets/MathBuddy2.png';
import q4VirtueImage from '../../Assets/Q4Virtue.png';
import ageCalcImage from '../../Assets/AgeCalc.png';
import alarmClockImage from '../../Assets/AlarmClock.png';
import breathMedAppImage from '../../Assets/breathMedApp.png';
import cropFinderImage from '../../Assets/cropFinder.png';
import skyModReviewsImage from '../../Assets/skyModReviews.png';
import utilityAppsImage from '../../Assets/utilityApps.png';
import utilityApps2Image from '../../Assets/utilityApps-2.png';

import physicsImage from '../../Assets/physics.png';
import portalImage from '../../Assets/portal.png';
import portfolio3dImage from '../../Assets/portfolio.png';
import gameAnimImage from '../../Assets/gameAnim.png';
import threeDAnimImage from '../../Assets/threeDAnim.png';

export const LAB_OWNER = {
  choicest: 'choicest',
  interns: 'interns',
};

export const ownerLabels = {
  [LAB_OWNER.choicest]: 'Choicest Fruit',
  [LAB_OWNER.interns]: 'Intern Projects',
};

/**
 * Keep this list simple + editable.
 * Add new projects by appending an item; the page UI will auto-update.
 */
export const labProjects = [
  {
    id: 'favrhood',
    owner: LAB_OWNER.choicest,
    title: 'Favrhood',
    description:
      'A neighborhood innovation hub built by Choicest Fruit—helping communities launch projects, share skills, and collaborate locally.',
    tags: ['Product', 'Community', 'Web App'],
    href: 'https://www.favrhood.com/',
    cta: 'Visit Favrhood',
    image: favrhoodLogo,
    featured: true,
  },

  // Intern web apps
  {
    id: 'ethical-tech-app',
    owner: LAB_OWNER.interns,
    title: 'Ethical Tech App',
    description:
      'Scenario-based app exploring ethical dilemmas in technology and product decisions.',
    tags: ['Web App', 'Ethics'],
    href: 'https://ishanisjm.github.io/EthicalTechApp/',
    cta: 'View Project',
    image: ethAppImage,
  },
  {
    id: 'math-buddy',
    owner: LAB_OWNER.interns,
    title: 'Math Buddy',
    description: 'Practice-friendly math helper built for learners.',
    tags: ['Web App', 'Education'],
    href: 'https://ishanisjm.github.io/mathBuddy/',
    cta: 'View Project',
    image: mathBuddyImage,
  },
  {
    id: 'quest-for-virtue',
    owner: LAB_OWNER.interns,
    title: 'Quest for Virtue',
    description: 'A browser game focused on values, decisions, and exploration.',
    tags: ['Game', 'Web'],
    href: 'https://universaltruth01.github.io/QuestForVirtue/',
    cta: 'View Project',
    image: q4VirtueImage,
  },
  {
    id: 'age-calculator',
    owner: LAB_OWNER.interns,
    title: 'Age Calculator',
    description: 'Quick utility for calculating age and milestones.',
    tags: ['Web App', 'Utility'],
    href: 'https://ellenscales19.github.io/ageCalculator',
    cta: 'View Project',
    image: ageCalcImage,
  },
  {
    id: 'alarm-clock',
    owner: LAB_OWNER.interns,
    title: 'Alarm Clock',
    description: 'A simple alarm clock experience for the browser.',
    tags: ['Web App', 'Utility'],
    href: 'https://nabilkalenga.github.io/Alarm-Clock/',
    cta: 'View Project',
    image: alarmClockImage,
  },
  {
    id: 'breathing-meditation-timer',
    owner: LAB_OWNER.interns,
    title: 'Breathing & Meditation Timer',
    description:
      'Breathing exercise and meditation timer with a calming animated circle, start/pause/reset controls, timer display, and a smooth mobile-friendly UI.',
    tags: ['Web App', 'Wellness', 'Utility'],
    href: 'https://choicest-fruit-llc.github.io/breathing-meditation-timer/',
    cta: 'View Project',
    image: breathMedAppImage,
  },
  {
    id: 'crop-companion-finder',
    owner: LAB_OWNER.interns,
    title: 'Crop Companion Finder',
    description:
      'Simple, mobile-friendly app that helps gardeners, students, and eco-tech enthusiasts explore plant companion relationships.',
    tags: ['Web App', 'Eco Tech', 'Education'],
    href: 'https://choicest-fruit-llc.github.io/crop-companion-finder/',
    cta: 'View Project',
    image: cropFinderImage,
  },
  {
    id: 'minecraft-mod-review-website',
    owner: LAB_OWNER.interns,
    title: 'Minecraft Mod Review Website',
    description:
      'SkyMod Reviews is a website for reviewing Minecraft mods, primarily focused on projects shared through Modrinth.',
    tags: ['Web App', 'Gaming', 'Reviews'],
    href: 'https://preoneanddone-code.github.io/Mod-Reviewing-Website/',
    cta: 'View Project',
    image: skyModReviewsImage,
  },
  {
    id: 'choicest-fruit-dashboard',
    owner: LAB_OWNER.interns,
    title: 'Choicest Fruit Dashboard',
    description:
      'Utility Apps Dashboard is a mobile-responsive web interface that acts as a central hub for utility apps, loading external web apps into the main content area with an iframe.',
    tags: ['Web App', 'Dashboard', 'Utility'],
    href: 'https://utilityappsorg.github.io/Utility-Apps/',
    cta: 'View Project',
    image: utilityAppsImage,
  },
  {
    id: 'utility-apps-dashboard',
    owner: LAB_OWNER.interns,
    title: 'Utility Apps Dashboard',
    description:
      'Built by the Utility Apps team during Choicest Fruit Internship 2025, this dashboard includes a Picture Converter, Text-to-PDF Converter, and Currency Converter.',
    tags: ['Web App', 'Dashboard', 'Utility'],
    href: 'https://utilityapps-choicest-fruit.github.io/Website-Dashboard/',
    cta: 'View Project',
    image: utilityApps2Image,
  },

  // Intern portfolios
  {
    id: 'portfolio-ishani',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Ishani Malismitha',
    tags: ['Portfolio'],
    href: 'https://ishanisjm.github.io/myWebsite/',
    cta: 'Open',
  },
  {
    id: 'portfolio-nathalia',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Nathalia Torres',
    tags: ['Portfolio'],
    href: 'https://nathaliat07.github.io/My-website/',
    cta: 'Open',
  },
  {
    id: 'portfolio-javaughn',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Javaughn Lamar',
    tags: ['Portfolio'],
    href: 'https://javaughn-223.github.io/My-website/',
    cta: 'Open',
  },
  {
    id: 'portfolio-emil',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Emil Trevino',
    tags: ['Portfolio'],
    href: 'https://emil-trevino.github.io/myWebsite/',
    cta: 'Open',
  },
  {
    id: 'portfolio-afseen',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Afseen Khandaker',
    tags: ['Portfolio'],
    href: 'https://afseenk.github.io/website/',
    cta: 'Open',
  },
  {
    id: 'portfolio-ellen',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Ellen Scales',
    tags: ['Portfolio'],
    href: 'https://ellenscales19.github.io/Website/',
    cta: 'Open',
  },
  {
    id: 'portfolio-preston',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Preston Scott Harter',
    tags: ['Portfolio'],
    href: 'https://preoneanddone-code.github.io/portfolio-website/',
    cta: 'Open',
  },
  {
    id: 'portfolio-zarya',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Zarya Foju',
    tags: ['Portfolio'],
    href: 'https://zaryafoju.github.io/my-portfolio/',
    cta: 'Open',
  },
  {
    id: 'portfolio-nicole',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Nicole Irielle',
    tags: ['Portfolio'],
    href: 'https://29nirielle-eng.github.io/personal-portfolio/',
    cta: 'Open',
  },
  {
    id: 'portfolio-keshav',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Keshav Korattur',
    tags: ['Portfolio'],
    href: 'https://kk2ktr2011-cloud.github.io/My-Portfolio/',
    cta: 'Open',
  },

  // 3D Web (intern showcase)
  {
    id: 'threejs-physics',
    owner: LAB_OWNER.interns,
    title: 'Real-Time Animations',
    description: 'Interactive physics + animation experiments for the web.',
    tags: ['3D Web', 'Three.js'],
    href: 'https://aaronenyetu.github.io/physics_threejs_and_rapier/',
    cta: 'View Project',
    image: physicsImage,
  },
  {
    id: 'portal-scene',
    owner: LAB_OWNER.interns,
    title: '3D Portal Scene',
    description: 'A stylized interactive portal environment.',
    tags: ['3D Web', 'Three.js'],
    href: 'https://3d-portal-scene.vercel.app/',
    cta: 'View Project',
    image: portalImage,
  },
  {
    id: 'three-d-portfolio',
    owner: LAB_OWNER.interns,
    title: '3D Portfolio Landing Page',
    description: 'A modern 3D landing page with motion and depth.',
    tags: ['3D Web', 'Portfolio'],
    href: 'https://3d-portfolio-landing-page.vercel.app/',
    cta: 'View Project',
    image: portfolio3dImage,
  },
  {
    id: 'animated-game-asset',
    owner: LAB_OWNER.interns,
    title: '3D Game Assets',
    description: 'Animated assets designed for interactive experiences.',
    tags: ['3D Web', 'Assets'],
    href: 'https://animated-game-asset.vercel.app/',
    cta: 'View Project',
    image: gameAnimImage,
  },
  {
    id: 'satisfying-loop',
    owner: LAB_OWNER.interns,
    title: '3D Physics Loops',
    description: 'Looping motion studies and satisfying physics timing.',
    tags: ['3D Web', 'Animation'],
    href: 'https://satisfying-loop-threejs.vercel.app/',
    cta: 'View Project',
    image: threeDAnimImage,
  },
];

export const featuredLabProject = labProjects.find((p) => p.featured) ?? labProjects[0];
